// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "main" + "." + "867c0b2f5378112c1dc6" + ".css";
};